<template>
  <div :style="getContainerStyle(data?.style)">
    <table align="center" width="100%" cellpadding="0" border="0" style="table-layout: fixed; border-collapse: collapse">
      <tbody>
        <tr>
          <td
            v-for="(column, index) in actualColumns"
            :key="index"
            :style="getColumnStyle(index, columnsCount, data?.props?.columnsGap, data?.props)"
          >
            <template v-if="column.childrenIds && column.childrenIds.length">
              <template v-for="childId in column.childrenIds" :key="childId" >
                <div class="component-container component" @mouseleave="isColumnActive = false">
                  <component
                    @click.stop="shareProps(childId, emailData[childId]) 
                    isColumnActive = true; currentColumn = childId"
                    :is="getComponentType(emailData[childId]?.type)"
                    :data="emailData[childId]?.data"
                    :blockId="childId"
                    :dynamicIndex ="dynamicIndex"
                    :emailData="emailData"
                    v-if="emailData[childId]"
                  ></component>
                  <div class="delete-button" 
                    @click.stop="deleteBlock(childId)" 
                    v-if="isColumnActive && currentColumn == childId">
                    <span class="material-symbols-outlined">delete</span>
                  </div>
                </div>
              </template>
            </template>
            
            <template v-else-if="currentView === 'Edit'">
              <EmptyBlock 
              @showAddList="showAddList($event, 'columns', data)" 
              :parentId="blockId" :parentType="'ColumnsContainer'"
              :index="index"/>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showAddButton" class="container-addButton top" @click.stop.self="toggleAddList($event, 'top')">+</div>
    <div v-if="showAddButton" class="container-addButton bottom" @click.stop.self="toggleAddList($event, 'bottom')">+</div>
    <AddList v-if="showAddList" :parentType = "'ColumnsContainer'" :style="addListStyle" @close="closeAddList" ref="addList" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EmptyBlock from './EmptyBlock.vue';
import HeadingBlock from './HeadingBlock.vue';
import HtmlBlock from './HtmlBlock.vue';
import TextBlock from './TextBlock.vue';
import SpacerBlock from './SpacerBlock.vue';
import ImageBlock from './ImageBlock.vue';
import ButtonBlock from './ButtonBlock.vue';
import DividerBlock from './DividerBlock.vue';
import RulesetBlock from './RulesetBlock.vue';
import QrBlock from './QrBlock.vue';
import ColumnsContainerBlock from './ColumnsContainerBlock.vue';
import ContainerBlock from './ContainerBlock.vue';
import AddList from '../Reusables/AddList.vue';

export default {
  name: 'ColumnsContainerBlock',
  components: {
    EmptyBlock, AddList
  },
  props: {
    data: Object,
    emailData: Object,
    blockId: String,
    dynamicIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['getView']),
   currentView() {
      return this.getView;
    },
    actualColumns() {
      return this.data?.props?.columns.slice(0, this.columnsCount) || [];
    },
    columnsCount() {
      return this.data?.props?.columnsCount || 1;
    },
  },
  data() {
    return {
      showAddButton: false,
      showAddList: false,
      addListStyle: {},
      isColumnActive: false,
      currentColumn: ''
    }},
  methods: {
    ...mapActions(['updateSharedData', 'removeBlock']),
    getContainerStyle(style) {
      const padding = style?.padding || { top: 0, bottom: 0, left: 0, right: 0 };
      const backgroundColor = style?.backgroundColor || 'transparent';
      return {
        padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
        backgroundColor: backgroundColor,
        position: 'relative',
      };
    },
    getColumnStyle(index, columnsCount, columnsGap, props) {
      const gap = columnsGap / 2 || 0;
      /* width: `${fixedWidths[index]}px` || 'auto' */
      let width;
      const check = props?.fixedWidths ?  true : false
      if(check){
      if (props?.fixedWidths && props?.fixedWidths[index]  && props?.fixedWidths[index] !== null ){
        width = `${props.fixedWidths[index]}px`
      } else {
        width = 'auto'
      }} else {
        width = 'auto'
      }
      return {
        boxSizing: 'content-box',
        verticalAlign: props?.verticalAlign ? props?.verticalAlign[index] : 'middle',
        paddingLeft: index === 0 ? 0 : `${gap}px`,
        paddingRight: index === columnsCount - 1 ? 0 : `${gap}px`, 
        width: width
      };
    },
    getComponentType(type) {
      const components = {
        Heading: HeadingBlock,
        Html: HtmlBlock,
        Text: TextBlock,
        Spacer: SpacerBlock,
        Image: ImageBlock,
        Container: ContainerBlock,
        Button: ButtonBlock,
        Divider: DividerBlock,
        ColumnsContainer: ColumnsContainerBlock,
        Ruleset: RulesetBlock,
        Qr: QrBlock,
      };
      return components[type] || 'div';
    },
    shareProps(childId, data) {
      this.updateSharedData({id: childId, data});
    },
    toggleAddList(event, position) {
      event.stopPropagation();
      const buttonRect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentElement.getBoundingClientRect();
      const top = position === 'top' ? buttonRect.top - parentRect.top : buttonRect.bottom - parentRect.top;
      const left = buttonRect.left - parentRect.left;

      this.addListStyle = {
        top: `${top}px`,
        left: `${left}px`,
        transform: 'translateY(20px)', // adjust as needed
        position: 'absolute',
        zIndex: 10,
      };
      this.showAddList = !this.showAddList;
      document.addEventListener('click', this.handleClickOutside);
     },
    handleClickOutside(event) {
      if (this.showAddList  && !event.target.closest('.add-list-popup')) {
        this.closeAddList();
      }
    },
    closeAddList() {
      this.showAddList = false;
      document.removeEventListener('click', this.handleClickOutside);
    },
    deleteBlock(childId) {
      this.removeBlock({ parentId: this.blockId, parentType: 'ColumnsContainer', blockId: childId}); 
      
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  };
</script>

<style scoped>
.component {
  position: relative;
}

.component:hover {
  box-shadow: 0 0 0 2px var(--primary-color);
  z-index: 10;
  /* border: 1px solid var(--primary-color); */
}

.component:active {
  border: 1px solid darkblue;
}

.container-addButton {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.container-addButton.top {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.container-addButton.bottom {
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.add-list {
  position: absolute;
  z-index: 10;
}

.component-container {
  position: relative;
}

.delete-button {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  padding: 5px;
  position: absolute;
  top: -10px;
  left: -10px;
  background: white;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

.component-container:hover .delete-button {
  opacity: 1;
}
</style>
